import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateInstituicao } from "../Usuario/api-usuario";
import { findByCurrentUser } from "./api-usuario-instituicao";
import { setUsuario } from "../Usuario/actions/actions";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import SettingsCard, { SelectableList } from "../Configuracao/SettingsCard";

export default function UsuarioInstituicaoTable() {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [usuarioInstituicoes, setUsuarioInstituicoes] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    findByCurrentUser().then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
      } else {
        setUsuarioInstituicoes(data);
      }
    });
  }, []);

  const handleAtivar = (ui) => {
    setIsSaving(true);
    updateInstituicao(ui.instituicao.codigo)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        dispatch(setUsuario(data));
        success("Instituição ativa alterada.");
      })
      .finally(() => setIsSaving(false));
  };

  if (usuarioInstituicoes.length === 0) return null;

  return (
    <SettingsCard
      title="Instituição Ativa"
      description="Instituição cujos dados são exibidos no sistema."
      contentPadding={false}
    >
      <SelectableList
        items={usuarioInstituicoes}
        getKey={(ui) => ui.codigo}
        getLabel={(ui) => ui.instituicao.descricao}
        isSelected={(ui) => usuario?.instituicao?.codigo === ui.instituicao.codigo}
        onSelect={handleAtivar}
        disabled={isSaving}
      />
    </SettingsCard>
  );
}
